var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C7.60571 7 8.19781 6.82039 8.70143 6.48388C9.20506 6.14737 9.59759 5.66907 9.82938 5.10947C10.0612 4.54987 10.1218 3.9341 10.0037 3.34004C9.88549 2.74597 9.59381 2.20029 9.16551 1.77199C8.73722 1.34369 8.19153 1.05201 7.59746 0.933846C7.0034 0.815679 6.38763 0.876327 5.82803 1.10812C5.26843 1.33991 4.79014 1.73244 4.45362 2.23607C4.11711 2.73969 3.9375 3.3318 3.9375 3.9375C3.9375 4.74973 4.26016 5.52869 4.83449 6.10302C5.40882 6.67735 6.18777 7 7 7ZM7 7.875C5.1018 7.875 1.3125 9.0475 1.3125 11.375V13.125H12.6875V11.375C12.6875 9.0475 8.8982 7.875 7 7.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/Icon_Person.3a8786d868ac2dbd1fb61c0e52ff0d06.svg";
export { ForwardRef as ReactComponent };